const GlobalError = {
    install: (Vue, options = {}) => {
        const defaultErrorHandler = (error, vm, info) => {
            console.group && console.group("global error captured:");
            console.error(vm);
            console.error(error);
            console.error(info);
            console.groupEnd && console.groupEnd();
        };
        const errorHandler = options.errorHandler || defaultErrorHandler;

        Vue.config.errorHandler = errorHandler;
        Vue.prototype.$throw = errorHandler;
    }
};

export default GlobalError;
